type DRFErrorBody = {
  [key: string]: string[] | DRFErrorBody
}

// Warning: this doesn't handle nested arrays of objects currently since it doesn't need to for this app
export const fixDRFErrorBody = (
  obj: DRFErrorBody,
  prefix: string = ""
): Record<string, string> => {
  return Object.entries(obj).reduce(
    (accumulator, [key, value]) => {
      const pre = prefix.length ? prefix + "." : ""

      if (Array.isArray(value)) {
        return {
          ...accumulator,
          [pre + key]: value[0],
        }
      } else if (
        typeof value === "object" &&
        value !== null
      ) {
        return {
          ...accumulator,
          ...fixDRFErrorBody(value, pre + key),
        }
      } else {
        return {
          ...accumulator,
          [pre + key]: value[0],
        }
      }
    },
    {}
  )
}

export const isDRFErrorBody = (
  body: unknown
): body is DRFErrorBody => {
  return typeof body === "object" && body !== null
}
